import { DriveType } from '@/api/main/types.gen'
import { Badge } from '@mantine/core'
import { FC } from 'react'

const DriveTypeBadge: FC<{ driveType: Set<DriveType> | Array<DriveType> }> = ({ driveType }) => {
  const badgeText = Array.from(driveType)
    .map(it => it[0])
    .join('')

  const isSingleLetter = badgeText.length === 1

  return (
    <Badge color="blue" size="xs" circle={isSingleLetter}>
      {badgeText}
    </Badge>
  )
}

export default DriveTypeBadge
